import BaseModal from "shared/modals/BaseModal";
import {getCookie} from "shared/networking/tools";
import ButtonInput from "shared/components/ButtonInput";

import "./styles.scss";


function ApplyModal({show, onClose, onApplyFull, onApplyQuick}) {
    const agency = {
        logo: getCookie('agency_logo'),
        name: getCookie('agency_name'),
    };

    const urlParams = new URLSearchParams(window.location.search);
    const showClientView = urlParams.get('showClientView') !== '0';

    return <BaseModal className={"ApplyModal"} show={show} onClose={onClose}>
        <h1 className={"ApplyModal__Title"}>How would you like to proceed?</h1>
        <img src={agency.logo} alt={agency.name}/>

        <div className={"ApplyModal__Options"}>
            <div className={"ApplyModal__Options__Option"}>
                <ButtonInput className={"ApplyModal__Options__Option__Button"} onClick={onApplyQuick}>
                    {showClientView ? 'Complete Quick App Form' : 'Client Pre-Screen Form'}<br/>
                    <i>(2-3 mins)</i>
                </ButtonInput>
                <p>
                    {showClientView
                        ? 'An advisor will call you to review the rest of the required info.'
                        : (
                            'Your client will complete basic health and financial info so you can properly ' +
                            'pre-screen and provide a proposal for your client.'
                        )
                    }
                </p>
            </div>
            <div className={"ApplyModal__Options__Separator"}/>
            <div className={"ApplyModal__Options__Option"}>
                <ButtonInput className={"ApplyModal__Options__Option__Button"} onClick={onApplyFull}>
                    {showClientView ? 'Complete Full App Form' : 'Client Universal Drop-Ticket'}<br/>
                    <i>(5-7 mins)</i>
                </ButtonInput>
                <p>
                    {showClientView
                        ? 'If fully completed we can submit your Inquiry directly to our insurance carriers.'
                        : (
                            'Your client will complete a universal Drop-Ticket that will include ' +
                            'complete demographic, health, and financial info. ' +
                            'Once completed this info can be used to submit a Drop-Ticket to any Carrier.'
                        )
                    }
                </p>
            </div>
        </div>
    </BaseModal>;
}

export default ApplyModal;
